// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"272":"7ee0331c","955":"7ee0331c"}[chunkId] + ".css";
};